import {
  createSelector,
  createFeatureSelector,
} from '@ngrx/store';
import * as fromTheoricalLayer from './theorical-layer.reducer';


// get the selectors
const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = fromTheoricalLayer.adapter.getSelectors();

export const selectTheoricalLayerState = createFeatureSelector<fromTheoricalLayer.State>('theoricalLayers');

export const selectTheoricalLayerIds = createSelector(
  selectTheoricalLayerState,
  selectIds
);
export const selectTheoricalLayerEntities = createSelector(
  selectTheoricalLayerState,
  selectEntities
);
export const selectAllTheoricalLayers = createSelector(
  selectTheoricalLayerState,
  selectAll
);
export const selectTheoricalLayerTotal = createSelector(
  selectTheoricalLayerState,
  selectTotal
);

export const selectCurrentReferenceTheoricalLayerId = createSelector(
  selectTheoricalLayerState,
  fromTheoricalLayer.getSelectedReferenceTheoricalLayerId
);

export const selectCurrentReferenceTheoricalLayer= createSelector(
  selectTheoricalLayerEntities,
  selectCurrentReferenceTheoricalLayerId,
  (entities, id) => (id) ? entities[id] : null
);
